module.exports = __webpack_public_path__ + "static/media/wwc-logo.19c620ff.jpg";